import { getLog } from '@eigtech/ui-shared-logging'

const log = getLog()

export function formatClaimMessage(message: string) {
  try {
    return message
      .replace(/&nbsp;/g, '') // cut back space chars
      .replace(/!\[CDATA\[/g, 'Information: ') //kill the cdata header
      .replace(/\]\]/g, '\n') //kill the cdata trailert
      .replace(/&#(x?)(\d+);/g, function (__$0, $1, $2) {
        return String.fromCharCode(parseInt($2, $1 ? 16 : 10))
      }) // replace ASCII literals cause
      .trim() //trim the result
  } catch (error) {
    log.error('could not format message', { error })
    return message
  }
}
